import "../../Styles/ambassadors.css";
import Button from "../../Components/Common/Button";
import Faq from "react-faq-component";
import { useEffect, useState } from "react";
import {
  Transaction_LandingPage,
  Transaction_LEGATE,
} from "../../Connections/Transaction";
import { Link, useNavigate } from "react-router-dom";
import SafiranPage from "./safiran-page";
import Toast from "../../Utils/Toast";

const Ambassadors = () => {
  const navigate = useNavigate();

  const [FAQ, setFAQ] = useState({});
  const [siteSetting, setSiteSetting] = useState({});
  const [social, setSocial] = useState([]);

  //copy link
  const [linkValue, setLinkValue] = useState("");
  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
    Toast("success", "لینک با موفقیت کپی شد!");
  };

  //invite number
  const [inviteNumber, setInviteNumber] = useState("");

  const handleInviteNumber = () => {
    const form = new FormData();
    form.append("Mobile", inviteNumber);

    if (inviteNumber && inviteNumber.length === 11) {
      Transaction_LEGATE.AddLegateInvite(form).then((res) => {
        if (res[0]) {
          console.log(res);
          Toast("success", "دوست شما با موفقیت دعوت شد");
        } else {
          Toast("error", res[1]);
        }
      });
    } else {
      Toast("error", "لطفا شماره را درست وارد کنید");
    }
  };

  //status
  const [accountCreatedStatus, setAccountCreatedStatus] = useState(false);

  //my legate info
  const [myLegateInfo, setMyLegateInfo] = useState();
  const [bestLegateList, setBestLegate] = useState([]);

  useEffect(() => {
    Transaction_LEGATE.GetTermAndCondition().then((res) => {
      if (res[0]) {
        const x = [];
        res[2].data.map((item) => {
          x.push({
            title: <div className="number-font">{item.title}</div>,
            content: <div className="number-font">{item.text}</div>,
          });
        });
        setFAQ({ rows: x });
      }
    });
    Transaction_LandingPage.siteSetting().then((res) => {
      if (res[0]) setSiteSetting(res[2].data);
    });
    Transaction_LandingPage.socialMedia().then((res) => {
      if (res[0]) setSocial(res[2].data);
    });
    Transaction_LEGATE.GetMyLegate().then((res) => {
      if (res[0]) {
        setLinkValue(res[2].data.myLink);
        setMyLegateInfo(res[2].data);
        setAccountCreatedStatus(true);
      } else {
        setAccountCreatedStatus(false);
      }
    });
    Transaction_LEGATE.GetBestLegate().then((res) => {
      if (res[0]) {
        setBestLegate(res[2].data);
      }
    });
  }, []);

  //handle register and start
  const handleRegister = () => {
    const token = localStorage.getItem("Token");
    console.log(token);
    if (!token) {
      navigate("/login-safiran");
    } else {
      navigate("/account-safiran");
    }
  };

  return (
    <SafiranPage>
      <div className="wrapper-ambassadors">
        <section className="first-section-ambassadors">
          {/* header background */}
          <img
            className="header-bg-stars mobile-hidden"
            src={
              "https://ketabno.com/static/media/first-section-background.5913a5be96843bbb494e.svg"
            }
            alt="bg"
          />
          <img
            className="desktop-hidden header-star-mobile"
            src={"/imgs/ambassadors/1000000952.svg"}
            alt="bg"
          />
          {/* header banner */}
          <div className="first-section-ambassadors-body">
            <div className="parent-header-logo-box">
              <div className="header-logo-box">
                <img
                  src="/imgs/ambassadors/bottle-banner.svg"
                  alt="bannerRight"
                  className="bottle-banner"
                />
                <div className="left-side-banner-text">
                  <div className="parent-left-side-logos">
                    <img
                      className="safiran-text-img"
                      src="/imgs/ambassadors/safiranTextLogo.svg"
                      alt=""
                    />
                    <img
                      className="logo-img-safiran"
                      src="/imgs/Landing/Logo.svg"
                      alt="logo"
                    />
                  </div>
                  <p className="desc-safiran-head">
                    سفیر شوید، دعوت کنید، هدیه بگیرید
                  </p>
                </div>
              </div>
            </div>
            {/* description */}
            <div className="section-end-part">
              <div className="desription-box">
                <p>
                  برای اینکه سفیر پویش بزرگ کتاب‌خوانی هیس‌طوری شوید، کافی‌ست که
                  نوجوان‌ها را به پویشِ هیس‌طوری و خواندن مجموعه ۱۵ جلدی سرگذشت
                  استعمار، دعوت‌ ‌کنید. به ‌ازای هر مدالی که نوجوان‌ها برای
                  خواندن کتاب‌ها می‌گیرند، هدیه‌ای به شما تقدیم می‌شود.
                </p>
              </div>
              {accountCreatedStatus ? (
                <div className="InviteFriends-inside-item2-left-bottom-parent">
                  <div className="parent-input-box-invite">
                    <p className="titile-invite-input-ambassadors">
                      شماره کسی که می‌خواهید دعوت کنید را بنویسید
                    </p>
                    <div className="input-in-ambassadors">
                      <div
                        style={{ marginTop: "20px" }}
                        className="InviteFriends-inside-item2-left-bottom copyLink-ambassador"
                      >
                        <input
                          style={{ backgroundColor: "#010a2b" }}
                          className="InviteFriends-inside-item2-left-bottom-input InviteFriends-inside-item2-left-bottom-input-safiran"
                          type="tel"
                          maxLength={11}
                          id="inviteNumber"
                          required
                          value={inviteNumber}
                          onChange={(e) =>
                            isNaN(e.target.value)
                              ? null
                              : setInviteNumber(e.target.value)
                          }
                        />
                        <label
                          htmlFor="Link"
                          className="InviteFriends-inside-item2-left-bottom-label"
                        >
                          شماره تلفن
                        </label>
                        <button
                          onClick={handleInviteNumber}
                          style={{ backgroundColor: "#3A37E5" }}
                          className="InviteFriends-inside-item2-left-bottom-button"
                        >
                          ارسال دعوتنامه
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="parent-input-box-invite">
                    <p className="titile-invite-input-ambassadors">
                      یا لینک دعوت را برای کسی که می‌خواهید دعوت کنید ارسال کنید
                    </p>
                    <div className="input-in-ambassadors">
                      <div
                        style={{ marginTop: "20px" }}
                        className="InviteFriends-inside-item2-left-bottom copyLink-ambassador"
                      >
                        <input
                          style={{ backgroundColor: "#010a2b" }}
                          className="InviteFriends-inside-item2-left-bottom-input InviteFriends-inside-item2-left-bottom-input-safiran"
                          type="text"
                          id="Link"
                          required
                          value={" "}
                        />

                        <span
                          className="link-ambasadors-input"
                          style={{
                            position: "absolute",
                            left: "50px",
                          }}
                        >
                          {linkValue}
                        </span>

                        <img
                          className="InviteFriends-inside-item2-left-bottom-icon"
                          src="/imgs/Profile/bx_link.svg"
                        />
                        <label
                          htmlFor="Link"
                          className="InviteFriends-inside-item2-left-bottom-label"
                        >
                          لینک دعوت
                        </label>
                        <button
                          className="InviteFriends-inside-item2-left-bottom-button"
                          onClick={() => copyToClipBoard(linkValue)}
                        >
                          کپی لینک
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div onClick={handleRegister} className="parent-start-btn">
                  <Button
                    customClass={"start-edventure-btn"}
                    text="ورود، ثبت‌نام و شروع‌"
                  />
                </div>
              )}
            </div>
          </div>
        </section>
        <section className="secound-section-ambassadors">
          <div className="first-banners">
            <div className="card-advertise">
              <img
                src="/imgs/ambassadors/add-young-history.svg"
                alt="ambassadors"
              />
              <p>دعوت نوجوانان به هیس‌طوری</p>
            </div>
            <div className="advertise-arrow-box">
              <img src="/imgs/Landing/Awards-arrow.svg" alt="" />
            </div>
            <div className="card-advertise">
              <img
                src="/imgs/ambassadors/read-book-youngs.svg"
                alt="ambassadors"
              />
              <p>خواندن کتاب توسط نوجوانان</p>
            </div>
          </div>
          <div className="mid-title">
            <p>دریافت هدیه به ازای مدال‌های دریافتی نوجوانان</p>
            <img
              src="/imgs/ambassadors/road-arrow-bottom.svg"
              alt="road-icon"
            />
          </div>
          <div className="Landing_main-third-section-top-row last-banners">
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/Awards.svg" alt="" />
              <p className="amount">
                <span className="number-font">2</span>هزار تومان
              </p>
              <p>برای هر مدال</p>
              <p>کتاب‌خوان تازه‌کار</p>
            </div>
            <div>
              <img
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
                className="arrow-svg"
              />
            </div>
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/javayez20.svg" alt="" />
              <p className="amount">
                <span className="number-font">3</span> هزار تومان
              </p>
              <p>برای هر مدال</p>
              <p>کتاب‌خوان فعال</p>
            </div>
            <div>
              <img
                className="arrow-svg"
                src="/imgs/Landing/Awards-arrow.svg"
                alt=""
              />
            </div>
            <div className="Landing_main-third-section-award-wrapper">
              <img src="/imgs/Landing/javayez10.svg" alt="" />
              <p className="amount">
                <span className="number-font">5</span> هزار تومان
              </p>
              <p>برای هر مدال</p>
              <p>کتاب‌خوان حرفه‌ای</p>
            </div>
          </div>
        </section>
        <section className="three-section-ambassadors">
          <div className="parent-know-box">
            <h2 className="know-ambassadors-title">
              آشنایی بیشتر با طرح سفیران هیس‌طوری
            </h2>
            {/* <iframe
              src="https://www.aparat.com/video/video/embed/videohash/15c96/vt/frame?titleShow=true&recom=self"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              className="get-know-ambassadors"
            ></iframe> */}
            <iframe
              src="https://www.aparat.com/video/video/embed/videohash/FHtIc/vt/frame?titleShow=true&recom=self"
              allowFullScreen="true"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              style={{ width: "100%" }}
              className="get-know-ambassadors"
            ></iframe>
          </div>
        </section>
        <section className="four-section-ambassadors">
          <h2 className="top-ambassadors-title">سفیران برتر هیس‌طوری</h2>
          {/* head buttons 1 */}
          <div className="top-ambassadors-buttons">
            <div className="title-lable-parent">
              <div className="title-lable-box">رتبه</div>
            </div>
            <div className="title-lable-parent">
              <div className="title-lable-box">تعداد دعوت</div>
            </div>
            <div className="title-lable-parent">
              <div className="title-lable-box">هدیه دریافتی</div>
            </div>
          </div>
          {/* list body */}
          <div className="winner-top-parent">
            {bestLegateList?.length === 0 && (
              <p style={{ marginTop: "20px", fontSize: "18px" }}>
                اطلاعاتی موجود نیست
              </p>
            )}
            {bestLegateList?.map((item, idx) => {
              return (
                <div key={idx} className="winner-top-ambassadors">
                  <span>{item?.no}</span>
                  <span className="winner-top-ambassadors-inivite">
                    {item?.inviteNo}
                  </span>
                  <div>
                    <span style={{ marginLeft: "5px" }}>
                      {item?.giftReceived}
                    </span>
                    <span>تومان</span>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
        <section className="Landing_main-twoelfth-section">
          <h1>قوانین و مقررات سفیران هیس‌طوری</h1>
          <Faq data={FAQ} config={config} />
        </section>
        <section
          style={{
            marginTop: "0px",
            borderTop: "0",
            borderTop: "2px solid #ea15ad",
          }}
          className="Landing_main-seventeenth-section"
        >
          <div className="Landing_main-seventeenth-section-right">
            <div className="Landing_main-seventeenth-section-right-bottom">
              <div
                style={{ marginBottom: "0px", marginRight: "10%" }}
                className="Landing_main-seventeenth-section-right-bottom-right"
              >
                <p
                  onClick={handleRegister}
                  className="Landing_main-seventeenth-section-right-bottom-right-title"
                >
                  ثبت‌نام و شروع
                </p>
                <Link to="/hisstori">سایت پویش هیس‌طوری</Link>
              </div>
              <div
                style={{ borderTop: "0px" }}
                className="Landing_main-seventeenth-section-right-bottom-center-right"
              >
                <div className="compony-info">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 1 16 16"
                      fill="none"
                    >
                      <path
                        d="M11.0466 14.6668C11.2237 14.6678 11.3992 14.6335 11.5628 14.566C11.7265 14.4985 11.8751 14.399 11.9999 14.2734L13.8066 12.4668C13.9308 12.3419 14.0005 12.1729 14.0005 11.9968C14.0005 11.8206 13.9308 11.6517 13.8066 11.5268L11.1399 8.86009C11.015 8.73593 10.8461 8.66623 10.6699 8.66623C10.4938 8.66623 10.3248 8.73593 10.1999 8.86009L9.13327 9.92009C8.39477 9.72319 7.71081 9.36069 7.13327 8.86009C6.63402 8.28163 6.27169 7.598 6.07327 6.86009L7.13327 5.79343C7.25744 5.66852 7.32714 5.49955 7.32714 5.32343C7.32714 5.1473 7.25744 4.97834 7.13327 4.85343L4.46661 2.18676C4.3417 2.06259 4.17273 1.9929 3.99661 1.9929C3.82048 1.9929 3.65152 2.06259 3.52661 2.18676L1.72661 4.00009C1.60103 4.12492 1.50157 4.27351 1.43404 4.43719C1.36651 4.60087 1.33225 4.77637 1.33327 4.95343C1.39376 7.51496 2.41732 9.95962 4.19994 11.8001C6.04042 13.5827 8.48508 14.6063 11.0466 14.6668ZM3.99994 3.60676L5.72661 5.33343L4.86661 6.19343C4.78515 6.26973 4.72416 6.36525 4.68922 6.47125C4.65427 6.57724 4.6465 6.69031 4.66661 6.80009C4.91579 7.91367 5.44335 8.94586 6.19994 9.80009C7.05351 10.5577 8.08596 11.0854 9.19994 11.3334C9.30806 11.356 9.4201 11.3514 9.52599 11.32C9.63188 11.2886 9.72831 11.2313 9.80661 11.1534L10.6666 10.2734L12.3933 12.0001L11.0599 13.3334C8.84909 13.2765 6.73961 12.3942 5.14661 10.8601C3.60855 9.26643 2.72368 7.15417 2.66661 4.94009L3.99994 3.60676ZM13.3333 7.33343H14.6666C14.6839 6.54076 14.5405 5.7528 14.2451 5.01703C13.9497 4.28126 13.5084 3.61292 12.9477 3.05229C12.3871 2.49166 11.7188 2.05034 10.983 1.75493C10.2472 1.45952 9.45927 1.31614 8.66661 1.33343V2.66676C9.28521 2.64536 9.9016 2.75143 10.4775 2.97838C11.0533 3.20533 11.5764 3.54831 12.014 3.98599C12.4517 4.42367 12.7947 4.9467 13.0217 5.52256C13.2486 6.09843 13.3547 6.71482 13.3333 7.33343Z"
                        fill="#C1C1C1"
                      />
                      <path
                        d="M8.66675 5.33333C10.0667 5.33333 10.6667 5.93333 10.6667 7.33333H12.0001C12.0001 5.18667 10.8134 4 8.66675 4V5.33333Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">مــرکز تماس و پشتیبانی: </p>
                  <div className="number-phone number-font">
                    <p className=" number-font">۰۹۲۱۱۱۰۱۵۱۶</p>
                  </div>
                  <div></div>
                </div>
                <div className="compony-info">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <path
                        d="M14.2222 3.40918H1.7778C1.54206 3.40918 1.31596 3.49857 1.14927 3.6577C0.982567 3.81682 0.888916 4.03263 0.888916 4.25766V12.7425C0.888916 12.9675 0.982567 13.1834 1.14927 13.3425C1.31596 13.5016 1.54206 13.591 1.7778 13.591H14.2222C14.458 13.591 14.6841 13.5016 14.8508 13.3425C15.0175 13.1834 15.1111 12.9675 15.1111 12.7425V4.25766C15.1111 4.03263 15.0175 3.81682 14.8508 3.6577C14.6841 3.49857 14.458 3.40918 14.2222 3.40918ZM13.5378 12.7425H2.51558L5.62669 9.671L4.98669 9.0813L1.7778 12.2504V4.90251L7.30225 10.1504C7.46879 10.3084 7.69408 10.3971 7.92892 10.3971C8.16375 10.3971 8.38904 10.3084 8.55558 10.1504L14.2222 4.771V12.1952L10.9511 9.07282L10.3245 9.671L13.5378 12.7425ZM2.36003 4.25766H13.5022L7.92892 9.54797L2.36003 4.25766Z"
                        fill="#C1C1C1"
                      />
                    </svg>
                  </div>
                  <p className="info">
                    پست الکترونیک:
                    <span className="site-setting">{siteSetting.email}</span>
                  </p>
                </div>
              </div>
              <div
                style={{ borderTop: "0px" }}
                className="Landing_main-seventeenth-section-right-bottom-center-right"
              >
                <div className="social-wrapper">
                  <p className="title">
                    هیس‌طوری رو توی شبکه‌های اجتماعی دنبال کنید!
                  </p>
                  <div className="social">
                    <a
                      className="social-link"
                      href={"https://rubika.ir/hisstori_ir"}
                      key={8}
                      target="_blank"
                    >
                      <img
                        src="https://api.ketabno.com/Landing/imgs/rubika.svg"
                        alt={`rubika icon`}
                      />
                    </a>
                    <a
                      className="social-link"
                      href={"https://www.aparat.com/hisstori_ir"}
                      key={3}
                      target="_blank"
                    >
                      <img
                        src="https://api.ketabno.com/Landing/imgs/aparat.svg"
                        alt={`aparat icon`}
                      />
                    </a>
                    <a
                      className="social-link"
                      href={"https://eitaa.com/hisstori_ir"}
                      key={4}
                      target="_blank"
                    >
                      <img
                        src="https://api.ketabno.com/Landing/imgs/eita.svg"
                        alt={`eitaa icon`}
                      />
                    </a>
                    <a
                      className="social-link"
                      href={"https://www.instagram.com/hisstori_ir"}
                      key={5}
                      target="_blank"
                    >
                      <img
                        src="https://api.ketabno.com/Landing/imgs/instagram.svg"
                        alt={`instagram icon`}
                      />
                    </a>
                    <a
                      className="social-link"
                      href={"https://shad.ir/hisstori_ir"}
                      key={6}
                      target="_blank"
                    >
                      <img
                        src="/imgs/ambassadors/shad-icon.svg"
                        alt={`shad icon`}
                      />
                    </a>
                    <a
                      className="social-link"
                      href={"http://ble.ir/join/OTU2MzQzND"}
                      key={7}
                      target="_blank"
                    >
                      <img
                        src="https://api.ketabno.com/Landing/imgs/bale.svg"
                        alt={`ble icon`}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer className="Landing_footer">
          <p className="footer-text">
            کلیه حقوق متعلق به <i className="text-purple">کتابنو</i> است
          </p>
        </footer>
      </div>
    </SafiranPage>
  );
};

const config = {
  arrowIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
    >
      <path
        d="M3.63574 3.52364V0.250909H5.7521V3.52364H9.13392V5.55273H5.7521V8.80364H3.63574V5.55273H0.232102V3.52364H3.63574Z"
        fill="#EA15AD"
      />
    </svg>
  ),
  animate: true,
  openOnload: 0,
};

export default Ambassadors;
